module.exports = __webpack_public_path__ + "img/placeholder_2.6fd9c69d.png";